import BurnPoolContent from "./BurnPoolContent";

export default BurnPoolContent;